import { PermissionString } from "@cervval.js/common-permissions";

export const CONNECTED_PS: PermissionString = "booking:connected:r";
export const PRO_PS: PermissionString = "booking:professional:r";